(function () {
  // Generic word-rotator: any element carrying data-words opts in
  // (gg-hero-statement sections, the gg-hero overlay). Static-mode
  // sections render no data-words and are never selected.
  const sections = document.querySelectorAll('[data-words]');
  if (!sections.length || !window.gsap) return;

  sections.forEach((section) => {
    // Static-mode sections have no rotating word — skip them entirely.
    if (section.dataset.mode !== 'dynamic') return;

    const wordEl   = section.querySelector('.gg-hero-statement__word, .gg-hero__word');
    if (!wordEl || !section.dataset.words) return;

    const words    = section.dataset.words.split(',').map(w => w.trim());
    const interval = parseInt(section.dataset.interval, 10) || 3000;
    let current    = 0;

    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      setInterval(() => {
        current = (current + 1) % words.length;
        wordEl.textContent = words[current];
      }, interval);
      return;
    }

    function cycleWord() {
      const next = words[(current + 1) % words.length];

      gsap.timeline()
        .to(wordEl, {
          y: '-0.3em',
          opacity: 0,
          scale: 0.92,
          duration: 0.3,
          ease: 'power2.in'
        })
        .call(() => {
          wordEl.textContent = next;
          gsap.set(wordEl, { y: '0.45em', opacity: 0, scale: 0.88 });
        })
        .to(wordEl, {
          y: '0em',
          opacity: 1,
          scale: 1,
          duration: 0.6,
          ease: 'power3.out'
        });

      current = (current + 1) % words.length;
    }

    setTimeout(() => {
      cycleWord();
      setInterval(cycleWord, interval);
    }, 1500);
  });
})();
